import React from 'react';
import {TransactionsEndpoints} from '../../common/ProxyEndpoints';
import Utils, {exportFilteredCSV} from "../../common/Utils";
import HTML from "../../common/HtmlHelpers";
import AnimatedNumber from 'react-animated-number';

import {
    Badge,
    Button,
    ButtonGroup,
    ButtonToolbar,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    UncontrolledButtonDropdown
} from 'reactstrap';
import DocumentTitle from 'react-document-title';
import {getTimeFrameRange} from '../Dashboard/DashboardCommon';
import MDProgress from 'react-md-progress-bar';
import MDSpinner from 'react-md-spinner';

import "./Transactions.css";
import TTLProxy from "../../common/TTLAsyncProxy";
import SmartDialog from "../../components/SmartDialog/SmartDialog";
import {ListItemView, PaginatedView} from "../../components/PaginatedView/PaginatedView";
import SessionStateManager from "../../common/SessionStateManager";
import AppGlobals from "../../common/AppGlobals";
import {TransactionStatus, TransactionType} from "../../common/Constants";
import ProfileAvatar from "../../components/ProfileAvatar/ProfileAvatar";
import ReactTimer from "../../common/ReactTimer";
import StatisticsChart from "../../components/StatisticsChart/StatisticsChart";
import AppVariables from "../../common/AppVariables";
import CurrencyLabel from "../../components/CurrencyLabel/CurrencyLabel";
import {CustomFilterFrame} from "../../components/CRUDView";
import ActiveView from "../../common/ActiveView";
import {css} from "glamor";
import DatePicker from 'react-datepicker';
import Icon from 'react-icons-kit';
import {exportIcon} from 'react-icons-kit/typicons/exportIcon';
import {ExpanderView, SectionedList, TextField} from "../../components/AuditExplorer/Elements";
import NumberLabel from "../../components/NumberLabel/NumberLabel";
import {renderStatus} from "../Request/RequestCommon";
import moment from 'moment';
import StandardValue from "../../common/StandardValue";
import {formatPaymentMethod, formatTransactionPaymentStatus, formatTransactionType} from "./TransactionHelpers";
import DataList from "../../components/TableListView/DataList";
import {ComparisonOperators} from "../../components/CRUDView/Components/ComparisonSelect";
import {formatServiceQuantity} from "../../common/QuantityHelper";

const brandInfo = '#63c2de';

/**
 * Transaction Log Item Style
 * @type {StyleAttribute}
 */
const txnLogStyle = css({
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: '#dfdfdf'
    }
});

const Styles = {

    header:{
        marginBottom : '45px'
    },

    frame: {
        backgroundColor: "white",
        padding: 20,
        width: "100%",
        height: "100%"
    },

    timeFrameLabel:{
        fontSize: '1rem',
        color: "#404040"
    },

    valueLabel:{
        fontSize: '0.8rem'
    }

};

const SearchProps = [ "message" , "ref" ];


//  The interval for updates
const UPDATE_INTERVAL = 4275;

const MoneyLabel = (props) => {
    return <strong className="h4"><span style={{color:'#585858' , fontSize: 'large' }}>{AppVariables.CurrencyCode}</span> <AnimatedNumber value={props.value} duration={800}
    formatValue={(number) =>  Math.floor(number).toLocaleString('en-us', { minimumFractionDigits: 0 })}
    style={{
        transition: '0.8s ease-out',
        transitionProperty: 'background-color, color, opacity'
    }} /> </strong>
};

const OptionGroup = (props) => {
    return <ButtonGroup>
        {props.options.map( (o,index) => <Button key={index} outline={props.selected != o.name} color={props.selected == o.name ? "green" : "secondary"} onClick={() =>{

            if(props.onSelect)
                props.onSelect(o.name);

        }}>{o.text}</Button>)}
    </ButtonGroup>
};

function moneyValue(m) {

    return m.toLocaleString(undefined,{
        maximumFractionDigits: 2
    });

}


class TransactionsLogsDisplay extends React.Component {

    constructor(props){
        super(props);
        this.state = TransactionsLogsDisplay.getInitialState();
        this.proxy = TTLProxy.getInstance();
    }

    static getInitialState(){

        return {
            errorMessage: null,
            isBusy: false,
            transactions: null,
            showFilters: false,
            contextItem: null,
            limit: 500,
            filters: {
                startDate: null,
                endDate: null,
                txnRef: '',
                amount: '',
                charges: '',
                status: '',
                type: '',
                requestID: '',
                phone: '',
                paymentMethod: ''
            }
        };

    }

    exportCSV(){

        return exportFilteredCSV(TransactionsEndpoints.exportCSV(),{
            queryHook: (url,options) => this.applyFilters(options),
            queryParams: {

            }
        });

    }

    applyFilters(options){

        const parseExpression = (expr) => {

            const result = {
                operator: "=",
                value: ""
            };

            let text = expr.trim();
            let op = ComparisonOperators.find(x => text.startsWith(x.symbol));
            if(op){
                result.operator = op.symbol;
            }

            result.value = text.replace(result.operator,"").trim();
            return result;
        };

        const { filters } = this.state;
        if(filters){

            const _filters = [];
            const query = (options.query  || (options.query = {}));

            if(filters.startDate){
                _filters.push({ key: "date_initiated" , operator: ">=" , value: moment(filters.startDate).toJSON() , cast: "datetime" })
            }

            if(filters.endDate){
                _filters.push({ key: "date_initiated" , operator: "<=" , value: moment(filters.endDate).toJSON() , cast: "datetime" })
            }

            if(filters.txnRef){
                _filters.push({ key: "id" , operator: "[]" , value: filters.txnRef });
            }

            if(filters.amount){
                _filters.push({ key: "actual_amount" , ...parseExpression(filters.amount) });
            }

            if(filters.charges){
                _filters.push({ key: "charges" , ...parseExpression(filters.charges) });
            }

            if(filters.requestID){
                _filters.push({ key: "request.order_id" , operator: "[]" , value: filters.requestID });
            }

            if(filters.phone){
                _filters.push({ key: "phone" , operator: "[]" , value: filters.phone });
            }

            if(filters.status){

                _filters.push({
                    key: "status" ,
                    operator: "=" ,
                    value: (() => {

                        switch (filters.status){
                            case 'success':
                                return TransactionStatus.Succeeded;
                            case 'fail':
                                return TransactionStatus.Failed;
                            case 'idle':
                                return TransactionStatus.Idle;
                        }

                    })()
                });
            }

            if(filters.type){
                query.filter_txn_type = filters.type;
            }

            if(filters.paymentMethod){
                query.filter_txn_payment_method = filters.paymentMethod;
            }

            options.filter = _filters;
        }

    }

    async loadState(){

        const proxy = this.proxy;

        this.setState({ isBusy: true });

        try{

            const options = {
                sort: [ '-date_initiated' ],
                include: [
                    { model: 'request' }
                ]
            };

            if(this.state.limit){

                options.pagination = {
                    offset: 0,
                    limit: this.state.limit
                };

            }

            //  apply filters to query params
            this.applyFilters(options);

            const response = await proxy.processRequest(TransactionsEndpoints.getUrl(),options);

            this.setState({
                transactions: response.getPayload(),
                errorMessage: null,
            });

        }
        catch (e) {

            this.setState({
                errorMessage: Utils.getResponseError(e),
            });

        }
        finally{

            this.setState({
                isBusy: false
            });

        }

    }

    show(){

        //  set state
        this.setState(TransactionsLogsDisplay.getInitialState(), () => {

            //  Load transactions
            this.loadState();

            //  Show dialog
            this._txnLogsDlg.show();

        });

    }

    /**
     * Transaction Info Dialog
     * Description:
     * Shows detailed info about transaction
     */
    static TransactionInfoDialog({ contextItem , dlgRef }){

        return <SmartDialog ref={dlgRef} title={"Transaction Info"} showCancelButton large>

            {contextItem && <React.Fragment>

                <ExpanderView title="Details" isExpanded className="mb-2">

                    <SectionedList items={[
                        {
                            title: "Reference",
                            value: contextItem.id
                        },
                        {
                            title: "Type",
                            value: formatTransactionType(contextItem)
                        },
                        {
                            title: "Status",
                            value: formatTransactionPaymentStatus(contextItem)
                        },
                        {
                            title: "Amount",
                            value: <NumberLabel value={contextItem.actual_amount}/>
                        },
                        {
                            title: "Currency",
                            value: contextItem.currency
                        },
                        {
                            title: "Wallet No.",
                            value: contextItem.mobile
                        },
                        {
                            title: "Time Initiated",
                            value: Utils.formatDateStandard(contextItem.date_initiated)
                        },
                        {
                            title: "Date Completed/Confirmed",
                            value: <StandardValue value={contextItem.date_completed}>{Utils.formatDateStandard(contextItem.date_completed)}</StandardValue>
                        },
                        {
                            title: "Payment Method",
                            value: formatPaymentMethod(contextItem)
                        },
                        {
                            title: "Additional Metadata",
                            mode: "vertical",
                            value: <TextField text={JSON.stringify(contextItem.meta)}/>
                        }
                    ]}/>

                </ExpanderView>

                <ExpanderView title="Tractor Request Info" isExpanded className="mb-2">

                    <SectionedList items={[
                        {
                            title: "ID",
                            value: contextItem.request.order_id
                        },
                        {
                            title: "Farmer",
                            value: `${contextItem.request.name} (${contextItem.request.phone})`
                        },
                        {
                            title: "Service",
                            value: contextItem.request.service.name
                        },
                        {
                            title: "Quantity",
                            value: formatServiceQuantity(contextItem.request, { acre: 'acres' , hectare: 'hectares' , service: contextItem.request.service })
                        },
                        {
                            title: "Location",
                            value: contextItem.request.location
                        },
                        {
                            title: "Time Requested",
                            value: Utils.formatDateStandard(contextItem.request.date_created)
                        },
                        {
                            title: "Current Status",
                            value: <span style={{display:"inline"}}>{renderStatus(contextItem.request)}</span>
                        }
                    ]}/>

                </ExpanderView>

                <ExpanderView title="Associated Transactions" isExpanded={false} alignContent={false}>

                    <DataList data={contextItem.request.transactions.filter(x => !(x.id === contextItem.id && x.type === contextItem.type))}
                              noRowsMessage="No additional associated transactions"
                              columns={[
                                  {
                                      key: "id",
                                      label: "Reference"
                                  },
                                  {
                                      key: "type",
                                      label: "Type",
                                      render: item => {
                                          return formatTransactionType(item);
                                      }
                                  },
                                  {
                                      key: "amount",
                                      label: "Amount",
                                      render: item => {
                                          return <CurrencyLabel value={item.actual_amount} currency={item.currency}/>
                                      }
                                  },
                                  {
                                      key: "status",
                                      label: "Status",
                                      render:  item => {
                                          return formatTransactionPaymentStatus(item);
                                      }
                                  }
                              ]}
                              responsive
                              hover={true}
                              itemsPerPage={5}/>

                </ExpanderView>

            </React.Fragment>}



        </SmartDialog>

    }

    setLimit(limit){

        this.setState({
            limit
        }, () => {

            //  reload state
            this.loadState();

        });

    }

    render(){

        const state = this.state;
        const { filters } = state;

        return <SmartDialog ref={dlg => this._txnLogsDlg = dlg}
                            classNames="fullscreen-modal-dialog"
                            contentClassName="fullscreen-modal-content-w100"
                            title={<span><i className="fa fa-list"/> Transactions Logs</span>}
                            showCancelButton={true}
                            large={true}>

            <TransactionsLogsDisplay.TransactionInfoDialog contextItem={state.contextItem} dlgRef={r => this._txnInfoDlg = r}/>

            { this.state.isBusy ? <div className="text-center">
                <MDSpinner size={45}/>
                <p>Loading transactions, please hold on...</p>
             </div>: <div>

                    <div className="clearfix mb-4">

                        <div className="pull-left">
                            <Row>

                                <Col md={6}>
                                    <b><i className="fa fa-calendar"/> Start Date</b><br/>
                                    <DatePicker ref={r => this._startDate = r}
                                                className="form-control form-input-select"
                                                dropdownMode="scroll"
                                                selected={filters.startDate}
                                                onSelect={value => this.setState({

                                                    filters: {
                                                        ...filters,
                                                        startDate: value
                                                    }

                                                })}
                                                showTimeInput/>
                                </Col>

                                <Col md={6}>
                                    <b><i className="fa fa-calendar"/> End Date</b><br/>
                                    <DatePicker ref={r => this._endDate = r}
                                                className="form-control form-input-select"
                                                dropdownMode="scroll"
                                                selected={filters.endDate}
                                                onSelect={value => this.setState({

                                                    filters: {
                                                        ...filters,
                                                        endDate: value
                                                    }

                                                })}
                                                showTimeInput/>
                                </Col>

                            </Row>
                        </div>

                        <div className="pull-right">

                            <ButtonToolbar className="mt-3">
                                <UncontrolledButtonDropdown color={"secondary"} className="mr-2">
                                    <DropdownToggle caret>Limit {state.limit ? `(${state.limit})` : '(None)'}</DropdownToggle>

                                    <DropdownMenu>
                                        <DropdownItem active={state.limit === 50} onClick={() => this.setLimit(50)}>50</DropdownItem>
                                        <DropdownItem active={state.limit === 100} onClick={() => this.setLimit(100)}>100</DropdownItem>
                                        <DropdownItem active={state.limit === 200} onClick={() => this.setLimit(200)}>200</DropdownItem>
                                        <DropdownItem active={state.limit === 300} onClick={() => this.setLimit(300)}>300</DropdownItem>
                                        <DropdownItem active={state.limit === 500} onClick={() => this.setLimit(500)}>500</DropdownItem>
                                        <DropdownItem active={state.limit === 1000} onClick={() => this.setLimit(1000)}>1000</DropdownItem>
                                        <DropdownItem active={state.limit === null} onClick={() => this.setLimit(null)}>No Limit</DropdownItem>
                                    </DropdownMenu>

                                </UncontrolledButtonDropdown>
                                <Button onClick={() => this.exportCSV()}><Icon icon={exportIcon}/> Export CSV</Button>
                                <Button onClick={() => this.loadState()}><i className="fa fa-refresh"/> Refresh</Button>
                                <Button title={"Toggle filters"} className="ml-2" active={state.showFilters} onClick={() => {

                                    this.setState(state => ({
                                        showFilters: !state.showFilters
                                    }));

                                }}>{this.state.showFilters ? <i className="fa fa-chevron-up"/> : <i className="fa fa-chevron-down"/> } Toggle Filters</Button>
                            </ButtonToolbar>

                        </div>

                    </div>

                    {this.state.showFilters && <CustomFilterFrame>

                        <Row>

                            <Col md={4}>
                                <b>Transaction ID/Reference</b>
                                <input ref={r => this._txnRef = r}
                                       type="text"
                                       placeholder="Enter reference"
                                       className="form-control form-input-select"
                                       value={filters.txnRef}
                                       onChange={evt => {

                                           this.setState({

                                               filters: {
                                                   ...filters,
                                                   txnRef: evt.target.value
                                               }

                                           });

                                       }}
                                />
                            </Col>

                           <Col md={4}>
                               <b>Transaction Type</b>
                               <select className="form-control form-input-select"
                                       value={filters.type}
                                       onChange={evt => {

                                            this.setState({

                                                filters: {
                                                    ...filters,
                                                    type: evt.target.value
                                                }

                                            })

                                       }}>
                                   <option value={''}>All</option>
                                   <option value={'charge'}>Receive/Charge</option>
                                   <option value={'refund'}>Refund</option>
                               </select>
                           </Col>


                            <Col md={4}>
                                <b>Transaction Status</b>
                                <select className="form-control form-input-select"
                                        value={filters.status}
                                        onChange={evt => {

                                            this.setState({

                                                filters: {
                                                    ...filters,
                                                    status: evt.target.value
                                                }

                                            })

                                        }}>>
                                    <option value={''}>All</option>
                                    <option value={'fail'}>Failed</option>
                                    <option value={'idle'}>Initiated (Pending)</option>
                                    <option value={'success'}>Successful</option>
                                </select>
                            </Col>


                        </Row>

                        <Row className="mt-2">

                            <Col md={4}>
                                <b>Amount</b>
                                <input ref={r => this._amount = r}
                                       type="text"
                                       min={0}
                                       placeholder="Enter amount expression"
                                       value={filters.amount}
                                       onChange={evt => {
                                           this.setState({

                                               filters: {
                                                   ...filters,
                                                   amount: evt.target.value
                                               }

                                           })
                                       }}
                                       className="form-control form-input-select"/>
                            </Col>

                            <Col md={4}>
                                <b>Charges</b>
                                <input ref={r => this._charges = r}
                                       type="text"
                                       placeholder="Enter charges expression"
                                       value={filters.charges}
                                       onChange={evt => {

                                           this.setState({
                                               filters: {
                                                   ...filters,
                                                   charges: evt.target.value
                                               }
                                           });

                                       }}
                                       className="form-control form-input-select"/>
                            </Col>


                            <Col md={4}>
                                <b>Wallet</b>
                                <input ref={r => this._phone = r}
                                       type="text"
                                       placeholder="Customer wallet/phone number"
                                       value={filters.phone}
                                       onChange={evt => {

                                           this.setState({

                                               filters: {
                                                   ...filters,
                                                   phone: evt.target.value
                                               }

                                           });

                                       }}
                                       className="form-control form-input-select"/>
                            </Col>

                        </Row>

                        <Row className="mt-2">

                            <Col md={4}>
                                <b>Tractor Request ID</b>
                                <input ref={r => this._reqOrderId = r}
                                       type="text"
                                       placeholder="Request ID"
                                       value={filters.requestID}
                                       onChange={evt => {

                                           this.setState({
                                               filters: {
                                                   ...filters,
                                                   requestID: evt.target.value
                                               }
                                           });

                                       }}
                                       className="form-control form-input-select"/>
                            </Col>

                            <Col md={4}>
                                <b>Payment Method</b>
                                <select className="form-control form-input-select"
                                        value={filters.paymentMethod}
                                        onChange={evt => {

                                            this.setState({
                                               filters: {
                                                   ...filters,
                                                   paymentMethod: evt.target.value
                                               }
                                            });

                                        }}>
                                    <option value={''}>All</option>
                                    <option value={'mobile'}>Mobile Money</option>
                                    <option value={'cash'}>Cash</option>
                                    <option value={'bank'}>Bank</option>
                                    <option value={'cheque'}>Cheque</option>
                                    <option value={'virtual_credit'}>Virtual Wallet</option>
                                </select>
                            </Col>

                        </Row>

                    </CustomFilterFrame>}

                    <hr/>

                    <PaginatedView rowHeight={240}
                                   noRowsHeight={380}
                                   height={480}
                                   data={state.transactions || []}
                                   emptyMessage="No transaction logs available"
                                   renderItem={(item) => {


                        return <ListItemView
                            style={{padding: 10}}
                            className={`${txnLogStyle}`}
                            onClick={() => {

                                this.setState({
                                    contextItem: item
                                }, () => {
                                    this._txnInfoDlg.show()
                                });

                            }}
                            separator={true}
                            iconRender={({ size }) => {

                                if(item.type & TransactionType.Charge)
                                    return <ProfileAvatar src="/img/icon_money.png" size={size}/>;
                                else if(item.type & TransactionType.Refund)
                                    return <ProfileAvatar src="/img/icon_refund.png" size={size}/>;

                            }}
                            title={<h5>{formatTransactionType(item)}</h5>}
                            subheader={ <div>

                                <div>
                                    <b>Reference: </b>
                                    <span>{item.id}</span>
                                </div>

                                <div>
                                    <b>Amount: </b>
                                    <span><CurrencyLabel value={item.actual_amount}/></span>
                                </div>

                                <div>
                                    <b>Wallet: </b>
                                    <span>{item.mobile}</span>
                                </div>

                                <div>
                                    <b>Status: </b>
                                    <span>{formatTransactionPaymentStatus(item)}</span>
                                </div>

                                <div>
                                    <b>Gateway Charges: </b>
                                    <span><CurrencyLabel value={item.amount_charged}/></span>
                                </div>

                                <div>
                                    <b>Date Initiated: </b>
                                    <span>{Utils.formatDateLong(item.date_initiated)}</span>
                                </div>

                                <div>
                                    <b>Date Completed: </b>
                                    <span>{item.date_completed ?  Utils.formatDateLong(item.date_completed) : "N/A"}</span>
                                </div>

                                <hr className="m-0 mb-1 mt-1"/>

                                <div>
                                    <b><i className="fa fa-chevron-right"/> Request: </b>
                                    <span>#{item.request.order_id} - {formatServiceQuantity(item.request,{ acre: 'acres', hectare: 'hectares' , service : item.request.service })}</span>
                                </div>

                            </div>}/>

                    }}/>

                </div>

               }

        </SmartDialog>
    }

}



class Transactions extends React.Component {

    constructor(props){
        super(props);

        const session = new SessionStateManager("transactions_admin",true);

        this.state = {

            isBusy: false,

            indicators: {
               major: false,
               flow: false,
               incomeSegmentation: false
            },

            segmentationView: session.getState("segmentationView","none"),

            incomeView: session.getState("incomeView", "week"),

            incomeFlowChart: session.getState("incomeFlowChart",{
                time_frame: session.getState("incomeView","week"),
                income: []
            }),

            summaryStats: session.getState("summaryStats",{

                //  The total amount of income generated  for completed requests
                income: {

                    //  Overall total income
                    total: 0,

                    //  Overall total commission
                    totalCommission: 0,

                    //  Overall total payout
                    totalPayout: 0,

                    //  Income generated today
                    today: 0,

                    //  Income generated this week
                    week: 0,

                    //  Income generated this month
                    month: 0,

                    //  Income generated this year
                    year: 0
                },

                refund: {

                    //  Total refunded amount
                    total: 0,

                    //  Amount refunded today
                    today: 0 ,

                    //  Amount refunded this week
                    week: 0,

                    //  Amount refunded this month
                    month: 0,

                    //  Income generated this year
                    year: 0
                },

                //  Income generated from completed requests
                totalCompletedIncome: 0,

                //  The total amount of income to be generated from only assigned requests
                totalPendingIncome: 0,

                //  The total amount of money commissioned for completed requests
                totalCommission: 0,

                //  The total amount of money to be commissioned for the currently assigned but not completed requests
                totalPendingCommission: 0,

                //  The total amount of money given out to Tractor Owners for completed requests
                totalPayouts: 0,

                //  The total amount of money pending to be given to tractor owner's for the currently assigned but not completed requests
                totalPendingPayout: 0,

                //  The total number of requests
                totalRequests: 0,

                //  The total number of requests that were paid for
                totalPaidRequests: 0,

                //  The total number of requests paid and completed
                totalCompletedPaidRequests: 0,

                //  The total number of request paid and unassigned
                totalUnassignedPaidRequests: 0
            }),

            incomeSegmentationStats: session.getState("incomeSegmentationStats",{

                cash: {
                    receive: 0,
                    refund: 0,
                    commission: 0,
                    payout: 0,
                },

                card:{
                    receive: 0,
                    refund: 0,
                    commission: 0,
                    payout: 0,
                },

                bank: {
                    receive: 0,
                    refund: 0,
                    commission: 0,
                    payout: 0,
                },

                mobileMoney:{
                    receive: 0,
                    refund: 0,
                    commission: 0,
                    payout: 0,
                },

                cheque: {
                    receive: 0,
                    refund: 0,
                    commission: 0,
                    payout: 0,
                },

                virtualCredit: {
                    receive: 0,
                    refund: 0,
                    commission: 0,
                    payout: 0
                },

                yolim: {
                    receive: 0,
                    refund: 0,
                    commission: 0,
                    payout: 0
                }
            })
        };

        //
        this.session = session;
        this._isMounted = false;
        this._timer = new ReactTimer(() => this.loadState(false).then(() => this._isMounted), UPDATE_INTERVAL  );

        //
        this.proxy = TTLProxy.getInstance();
    }

    setStateSafe(state){

        if(this._isMounted){
            this.setState(state);
        }

    }

    getSessionState(){

        const state = this.state;
        return {
            segmentationView: state.segmentationView,
            incomeView: state.incomeView,
            incomeFlowChart: state.incomeFlowChart,
            summaryStats: state.summaryStats,
            incomeSegmentationStats: state.incomeSegmentationStats
        };

    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    componentDidMount(){

        //  set mounted
        this._isMounted = true;

        //  Load application state
        this.loadState(true).then(() => this._timer.start());
    }

    loadSummary(){

        return this.proxy.processRequest(TransactionsEndpoints.getSummary()).then(response =>{

            this.setStateSafe({
                summaryStats: response.getPayload()
            });

            return response.ok;
        });
    }


    loadIncomeSegmentationStats(view,indicator = false){

        const state = this.state;
        this.setIndicator("incomeSegmentation",indicator);

        return this.proxy.processRequest(TransactionsEndpoints.getSegmentedIncomeStats(view == "none" ? undefined : view)).then(response => {

            this.setStateSafe({
                incomeSegmentationStats: response.getPayload(),
            });

            if(indicator)
                this.setIndicator("incomeSegmentation",false);

            return response.ok;
        });

    }

    loadIncomeFlowChart(view,indicator = false){

        const state = this.state;

        this.setIndicator("flow",indicator);

        return this.proxy.processRequest( TransactionsEndpoints.generateIncomeFlowChart(view, getTimeFrameRange(view) )).then(response =>{

            const data = response.getPayload();

            this.setStateSafe({
                incomeFlowChart: data
            });

            if(indicator)
                this.setIndicator("flow",false);

            return response.ok;
        });

    }

    setIndicator(name , value){

        let indicators = this.state.indicators;
        indicators[name]  = value;
        this.setStateSafe({
            indicators: indicators
        });

    }


    loadState(indicator = true){

        const me = this;
        const state = this.state;

        this.setIndicator("major", indicator);

        this.setStateSafe({
            isBusy: true,
        });

        function done() {

            //
            me.setStateSafe({
                isBusy: false
            });

            //
            me.setIndicator("major",false);
        }

        return Promise.all([

            //  get summary
            this.loadSummary(),

            //  get income segmentation
            this.loadIncomeSegmentationStats(state.segmentationView),

            //  get time frame range
            this.loadIncomeFlowChart(state.incomeView)

        ]).then(values => {

            //
            done();

        }).catch(err => {

            //
            done();

            //  Toast error
            HTML.toastWarning(Utils.getResponseError(err));

        });

    }

    render(){

        const state = this.state;
        const indicators = state.indicators;
        const isMobile = AppGlobals.get('isMobile');

        return <DocumentTitle title={"Transactions"}>
            <ActiveView view={() => this}>
                <div>
                    {<MDProgress show={state.indicators.major}/>}
                    <div className="container-fluid">

                        <div className="animated fadeIn">

                            <div className="content-frame">

                                {/*  */}
                                <div style={Styles.frame} className="txn-pane">

                                    <div className="row">

                                        <div className="col-md-6 text-center">
                                            <h6><Badge color="secondary" pill>Total</Badge></h6>
                                            <p><b style={{fontSize: 28 , marginRight: 10 }}>{AppVariables.CurrencyCode}</b> <span style={{ fontSize: '4rem' }}>{moneyValue(state.summaryStats.income.total)}</span></p>
                                        </div>

                                        <div className={`col-md-6 ${isMobile ? 'text-center' : ''}`}>

                                            <b style={Styles.timeFrameLabel}>Today</b>
                                            <div className="row">

                                                <div className="col-md-6" style={Styles.valueLabel}>
                                                    <span>Received: <CurrencyLabel value={state.summaryStats.income.today}/></span>
                                                </div>

                                                <div className="col-md-6" style={Styles.valueLabel}>
                                                    <span>Refunded: <CurrencyLabel value={state.summaryStats.refund.today}/></span>
                                                </div>

                                            </div>

                                            <hr/>

                                            <b style={Styles.timeFrameLabel}>This Week</b>
                                            <div className="row">

                                                <div className="col-md-6" style={Styles.valueLabel}>
                                                    <span>Received: <CurrencyLabel value={state.summaryStats.income.week}/></span>
                                                </div>

                                                <div className="col-md-6" style={Styles.valueLabel}>
                                                    <span>Refunded: <CurrencyLabel value={state.summaryStats.refund.week}/></span>
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                    <hr/>

                                    <div className={`clearfix ${isMobile ? 'text-center' : ''}`}>

                                        <div className="pull-left">
                                            <p style={Styles.valueLabel}>Total Refunded:  <CurrencyLabel value={moneyValue(state.summaryStats.refund.total)}/></p>
                                        </div>

                                        <div className="pull-right">

                                            <ButtonGroup>
                                                <Button color={"green"} onClick={() => this._txnLogsDlg.show() }><i className="fa fa-list"></i> See Transactions Logs</Button>
                                                <Button onClick={() => this.loadState(true) }><i className="fa fa-refresh"></i> Refresh</Button>
                                            </ButtonGroup>

                                        </div>

                                    </div>

                                </div>

                                <br/>

                                <div className="row">

                                    <div className="col-md-6">

                                        <div className="txn-pane-light txn-pane-bordered" style={Styles.frame}>

                                            <div className="text-center">
                                                <h4><b>Commission</b></h4>
                                                <p><b style={{fontSize: 18 , marginRight: 10 }}>{AppVariables.CurrencyCode}</b> <span style={{fontSize: 65}}>{moneyValue(state.summaryStats.income.totalCommission)}</span></p>
                                                <hr/>

                                                <div className="row">

                                                    <div className="col-md-6">

                                                        <div className="text-center">
                                                            <h6 style={{color:"gray"}}>Completed Requests (Commission)</h6>
                                                            <p><b style={{fontSize: 14 , marginRight: 10 }}>{AppVariables.CurrencyCode}</b> <span style={{fontSize: 30}}><b>{moneyValue(state.summaryStats.totalCommission)}</b></span></p>
                                                        </div>

                                                    </div>

                                                    <div className="col-md-6">

                                                        <div className="text-center">
                                                            <h6 style={{color:"gray"}}>Assigned Requests (Commission)</h6>
                                                            <p><b style={{fontSize: 14 , marginRight: 10 }}>{AppVariables.CurrencyCode}</b> <span style={{fontSize: 30}}><b>{moneyValue(state.summaryStats.totalPendingCommission)}</b></span></p>
                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                    <div className="col-md-6">

                                        <div className="txn-pane-light txn-pane-bordered" style={Styles.frame}>

                                            <div className="text-center">
                                                <h4><b>Payout</b></h4>
                                                <p><b style={{fontSize: 18 , marginRight: 10 }}>{AppVariables.CurrencyCode}</b> <span style={{fontSize: 65}}>{moneyValue(state.summaryStats.income.totalPayout)}</span></p>
                                                <hr/>

                                                <div className="row">

                                                    <div className="col-md-6">

                                                        <div className="text-center">
                                                            <h6 style={{color:"gray"}}>Completed Requests (Payouts)</h6>
                                                            <p><b style={{fontSize: 14 , marginRight: 10 }}>{AppVariables.CurrencyCode}</b> <span style={{fontSize: 30}}><b>{moneyValue(state.summaryStats.totalPayouts)}</b></span></p>
                                                        </div>

                                                    </div>

                                                    <div className="col-md-6">

                                                        <div className="text-center">
                                                            <h6 style={{color:"gray"}}>Assigned Requests (Payouts)</h6>
                                                            <p><b style={{fontSize: 14 , marginRight: 10 }}>{AppVariables.CurrencyCode}</b> <span style={{fontSize: 30}}><b>{moneyValue(state.summaryStats.totalPendingPayout)}</b></span></p>
                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>


                                <br/>

                                <div>
                                    <div className="txn-pane" style={Styles.frame}>
                                        <div className="clearfix">

                                            <div className="pull-left">
                                                <h5>Income Segmentation (Payment Method)</h5>
                                            </div>

                                            <div className="pull-right">

                                                <OptionGroup selected={this.state.segmentationView} options={[
                                                    {
                                                        name: "none",
                                                        text: "None"
                                                    },
                                                    {
                                                        name: "week",
                                                        text: "Week"
                                                    },
                                                    {
                                                        name: "month",
                                                        text: "Month"
                                                    },
                                                    {
                                                        name: "year",
                                                        text: "Year"
                                                    }
                                                ]} onSelect={(name) => {

                                                    this.loadIncomeSegmentationStats(name,true).then(() =>{

                                                        this.setStateSafe({
                                                            segmentationView: name
                                                        });

                                                    });

                                                }}/>

                                            </div>

                                        </div>
                                        <hr/>
                                        <div className="row" style={{marginTop: 20}}>

                                            <div className="col-md-3">
                                                <h6><i className="fa fa-money"></i> Bank Payment</h6>
                                                <div>
                                                    <span><h4 style={{display: "inline"}}>{moneyValue(state.incomeSegmentationStats.bank.receive + state.incomeSegmentationStats.bank.refund)}</h4> {AppVariables.CurrencyCode}</span>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <h6><i className="fa fa-credit-card"></i> Card</h6>
                                                <div>
                                                    <span><h4 style={{display: "inline"}}>{moneyValue(state.incomeSegmentationStats.card.receive + state.incomeSegmentationStats.card.refund)}</h4> {AppVariables.CurrencyCode}</span>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <h6><i className="fa fa-mobile"></i> Mobile Money</h6>
                                                <div>
                                                    <span><h4 style={{display: "inline"}}>{moneyValue(state.incomeSegmentationStats.mobileMoney.receive + state.incomeSegmentationStats.mobileMoney.refund)}</h4> {AppVariables.CurrencyCode}</span>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <h6><i className="fa fa-credit-card-alt"></i> Virtual Wallet</h6>
                                                <div>
                                                    <span><h4 style={{display: "inline"}}>{moneyValue(state.incomeSegmentationStats.virtualCredit.receive + state.incomeSegmentationStats.virtualCredit.refund)}</h4> {AppVariables.CurrencyCode}</span>
                                                </div>
                                            </div>

                                        </div>
                                        <br/>

                                        {indicators.incomeSegmentation && <MDProgress show={true}/>}

                                    </div>
                                </div>

                                <br/>

                                <div className="txn-pane" style={Styles.frame}>

                                    <div>

                                        <StatisticsChart
                                            height={300}
                                            sessionKey="txn_income_flow_chart"
                                            onTimeFrameChanged={(frame) => {

                                                //  refresh diagram
                                                this.loadIncomeFlowChart(frame,true).then(() =>{

                                                    this.setStateSafe({
                                                        incomeView: frame
                                                    });

                                                });

                                            }}
                                            title={<span><i className="fa fa-line-chart"></i> Revenue Flow</span>}
                                            ref={(input)=> this._incomeFlowChart = input}
                                            sections={[
                                                {
                                                    key: 'income',
                                                    borderWidth: 2,
                                                    backgroundColor: Utils.convertHex(brandInfo,10),
                                                    borderColor: brandInfo,
                                                    label: `Revenue Received (${AppVariables.CurrencyCode})`
                                                }
                                            ]}
                                            keepState={true}
                                            data={this.state.incomeFlowChart} />

                                    </div>

                                    {indicators.flow && <MDProgress show={true}/>}

                                </div>

                                <br/>

                            </div>

                        </div>

                        <TransactionsLogsDisplay ref={dlg => this._txnLogsDlg = dlg }/>

                    </div>

                </div>
            </ActiveView>
        </DocumentTitle>
    }


}

export default Transactions;



// WEBPACK FOOTER //
// ./src/views/Transactions/Transactions.js